import { Link } from "react-router-dom";
import { config } from "./config"
import {  getDocumentInfo } from "./utilityFunctions";

export const getDocURL = (groupId) => {
    var base = config.fileDownloadUrl;
    var url = base + "/api/dlms/downloadDocument?groupId=" + groupId;
    return url;
}

export const getDocInfo = async (groupId) => {
    if (groupId != null && groupId != "") {
        return getDocumentInfo(groupId).then((res) => {
            config.isDebugEnabled && console.log(res);
            var d = res.data;
            return d;
        }).catch((error) => {
            config.isDebugEnabled && console.log("Error caught while loading data: " + error);
        });
    }
}

export const getResourceDownloadProps = (groupId) => {
    return ({
        as:Link, 
        to: getDocURL(groupId),
        target:"_blank",
        download: true
    })
}